/** Устаревшее значение радиуса скругления кнопки */
export const DEPRECATED_BORDER_RADIUS = 4;

/** По дизайну у всех кнопок должен быть border-radius: 8px */
export const DESIGN_BORDER_RADIUS = 8;

/** По дизайну у всех кнопок должна быть анимация клика */
export const DESIGN_CLICK_ANIMATION = true;

export const BORDER_RADIUSES = [4, 8] as const;

/**
 * TODO: Удалить лишние варианты
 * view='outlined' будет удален в следующих мажорных версиях. Используйте view='tertiary'
 * view='filled' будет удален в следующих мажорных версиях. Используйте view='secondary'
 * view='transparent' будет удален в следующих мажорных версиях. Используйте view='secondary'
 */
export const VIEWS = [
    'primary',
    'filled',
    'transparent',
    'secondary',
    'outlined',
    'tertiary',
    'link',
    'ghost',
] as const;

export const SIZES = ['xxs', 'xs', 's', 'm', 'l'] as const;

export const COLORS = ['default', 'inverted'] as const;
